import { IconFont, pointer } from '@lighthouse/bui'
import styled from 'styled-components'

export const Icon = styled(IconFont)<{ mr?: number }>`
    font-size: 16px;
    color: var(--color-gray-400);
    ${pointer};
    margin-right: ${({ mr }) => mr ?? 0}px;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    /* gap: 8px; */
    width: 100%;
    height: 100%;
    overflow: hidden;
`

export const Item = styled.div`
    background: #eceff4;
    padding: 8px 12px;
    border-radius: 8px;
    margin-bottom: 12px;
    &:last-child {
        margin-bottom: 4px;
    }
`

export const ItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 22px;
`

export const ItemLeft = styled.div`
    display: flex;
    align-items: center;
    line-height: 22px;
`

export const ParameterType = styled.div`
    color: var(--color-gray-700);
    font-weight: 600;
    font-size: 14px;
`

export const ParameterText = styled.div`
    padding: 0 8px;
    color: var(--color-gray-400);
    font-weight: var(--font-weight-normal);
    font-size: 12px;
`

export const ParameterRequired = styled.div`
    color: var(--color-purple-500);
    font-weight: var(--font-weight-normal);
    font-size: 12px;
`

export const ItemRight = styled.div`
    line-height: 22px;
    display: flex;
    align-items: center;
`

export const ItemContent = styled.div`
    line-height: 20px;
    color: var(--color-gray-500);
    font-weight: var(--font-weight-normal);
    font-size: 12px;
    margin-top: 4px;
`

export const TooltipContent = styled.div`
    line-height: 22px;
    vertical-align: middle;
`
